import { assertInInjectionContext, inject } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    CanActivateFn,
    Router,
    RouterStateSnapshot
} from '@angular/router';
import { Store } from '@ngxs/store';
import { AuthState } from '@tsin-core/states/auth.state';
import { environment } from '@tsin-env/environment';

const canActivateChildFn: CanActivateFn = (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
) => {
    assertInInjectionContext(canActivateChildFn);
    const router: Router = inject(Router);
    const store: Store = inject(Store);

    const isLogin = store.selectSnapshot(AuthState.getIsAuthenticated);
    if (!isLogin) {
        return router.parseUrl('/account/validate-login');
    }

    const user = store.selectSnapshot(AuthState.getCurrentUser);
    const targetPath = route.routeConfig?.path;

    if (user?.isStaff && user?.staffType !== 'Full Time') {
        if (targetPath !== 'user') {
            return router.parseUrl('/user');
        }
        return true;
    }
    const roles = ['User', 'examAdmin', 'proAdmin', 'learnerAdmin', 'facilitatorAdmin'];
    if (user?.staffType === 'Casual Staff') {
        if (targetPath === 'employee') {
            return true;
        }
        return router.parseUrl('/employee');
    }
    if (roles.includes(user?.role as string) && user?.staffType === 'Full Time') {
        if (targetPath === 'employee') {
            return true;
        }
        return router.parseUrl('/employee');
    }

    const roleAccessMap: Record<string, string> = {
        superAdmin: 'management',
        hrAdmin: 'management',
        facilitatorAdmin: 'management',
        admin: 'managers',
        financeAdmin: 'finance',
        financeHeadAdmin: 'finance',
        itAdmin: 'IT'
    };

    const allowedPath = roleAccessMap[user?.role as string];

    if (user?.isStaff && user?.staffType === 'Full Time') {
        if (targetPath === allowedPath || targetPath === 'employee') {
            return true;
        }
        return router.parseUrl(`/${allowedPath}`);
    }

    // return router.parseUrl('/user');
    return true;
};

export const adminGuard: CanActivateFn = (route, state) => {
    return canActivateChildFn(route, state);
};
